/**
 * Query-string helpers for InComm cardholder list drill-downs (dashboard → list).
 */

import type {
  IncommCardsSummaryResponse,
  PartnerCardBreakdownResponse,
} from '@/app/services/incommCardService';

/** Hash-router list URL uses this flag (maps to API `card_status_is_null`). */
export const INCOMM_LIST_QUERY_UNSET = 'card_status_unset';

export function countUnsetCardholdersFromSummary(summary: IncommCardsSummaryResponse): number {
  const row = summary.card_status_counts.find((c) => c.status == null);
  return row?.count ?? 0;
}

export function countUnsetCardholdersForPartner(
  breakdown: PartnerCardBreakdownResponse,
  partnerProductId: number
): number {
  const item = breakdown.items.find((i) => i.partner_product_id === partnerProductId);
  if (item == null) return 0;
  const row = item.counts.find((c) => c.status == null);
  return row?.count ?? 0;
}

export function totalCardholdersForPartner(
  breakdown: PartnerCardBreakdownResponse,
  partnerProductId: number
): number {
  const item = breakdown.items.find((i) => i.partner_product_id === partnerProductId);
  return item?.total_count ?? 0;
}

/** Build `?a=1&b=2` for `/incomm-cards/list` navigation. */
export function buildIncommListSearchString(opts: {
  cardStatusUnset?: boolean;
  /** Raw `incomm_demo.card_status` (mutually exclusive with `cardStatusUnset`). */
  cardStatus?: string | null;
  partnerProductId?: number | null;
}): string {
  const q = new URLSearchParams();
  if (opts.cardStatusUnset) {
    q.set(INCOMM_LIST_QUERY_UNSET, '1');
  } else if (opts.cardStatus != null && opts.cardStatus.trim() !== '') {
    q.set('card_status', opts.cardStatus.trim());
  }
  if (opts.partnerProductId != null) {
    q.set('partner_product_id', String(opts.partnerProductId));
  }
  const s = q.toString();
  return s === '' ? '' : `?${s}`;
}
